services.service('ServerTimeService', ['API', 'Storage', function (API, Storage) {
    var self = this;

    var now = new Date();
    this.time = Date.now();
    this.serverTimezone = 3; // we'll get this value from socket on start
    this.clientTimeZone = -now.getTimezoneOffset() / 60;
    this.timeZoneOffset = 0;

    this.init = function () {
        log('start ServerTimeService');
        Storage.load('timezone').then(function(){
            self.serverTimezone = parseInt(Storage.get('timezone'), 10);
            self.timeZoneOffset = self.clientTimeZone - self.serverTimezone;
        });
        API.subscribe('serverTime', update);
    };

    function update(time) {
        self.time = parseInt(parseInt(time, 10) * 1000, 10);
    }

    this.clear = function () {
        log('clear ServerTimeService');
        API.unsubscribe('serverTime', update);
    };

    return this;
}]);